<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="$t('views.shipment_notice_creation.clear_tables')"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    @hide="hide"
  >
    <div class="spso-modal__body">
      <p class="delete-action-modal__text">
        {{ $t('views.shipment_notice_list.cancel') }}
        <br>
        {{ $t('views.shipment_notice_creation.clear_tables_question') }}
      </p>
    </div>
    <div class="v-application d-flex">
      <v-btn
        class="mr-4 flex-grow-1"
        outlined
        large
        @click="hide"
      >
        {{ $t('common.no') }}
      </v-btn>
      <v-btn
        color="primary"
        class="flex-grow-1"
        outlined
        large
        @click="confirm"
      >
        {{ $t('common.yes') }}
      </v-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CancelModal',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      isShown: false,
    };
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    hide() {
      this.$emit('input', false);
    },

    confirm() {
      this.$emit('confirm', this.id);
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.delete-action-modal__text {
  text-align: center;
  margin-bottom: 0;
}
</style>
